// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__5F-15","p":"Menu_p__2AZBO","close":"Menu_close__ATCSk","rotate":"Menu_rotate__J3Vea","logo":"Menu_logo__fSN-I"};